import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { AppRoutes, RouteParams } from "./enums";

const routes: Routes = [
  {
    path: AppRoutes.notFound,
    loadChildren: () => import("./pages/not-found/not-found.module").then(m => m.NotFoundPageModule),
  },
  {
    path: `:${RouteParams.programSlug}`,
    children: [
      {
        path: AppRoutes.check,
        loadChildren: () => import("./pages/check/check.module").then(m => m.CheckPageModule),
      },
      {
        path: AppRoutes.sendPass,
        loadChildren: () => import("./pages/send-pass/send-pass.module").then(m => m.SendPassPageModule),
      },
      {
        path: AppRoutes.passSent,
        loadChildren: () => import("./pages/pass-sent/pass-sent.module").then(m => m.PassSentPageModule),
      },
      {
        path: AppRoutes.register,
        loadChildren: () => import("./pages/register/register.module").then(m => m.RegisterPageModule),
      },
      {
        path: AppRoutes.verify,
        loadChildren: () => import("./pages/validate/validate.module").then(m => m.ValidatePageModule),
      },
      {
        path: AppRoutes.download,
        loadChildren: () => import("./pages/download/download.module").then(m => m.DownloadPageModule),
      },
      {
        path: AppRoutes.downloaded,
        loadChildren: () => import("./pages/downloaded/downloaded.module").then(m => m.DownloadedPageModule),
      },
      // Legacy route redirections from profile to loyalty
      {
        path: `${AppRoutes.profile}/${AppRoutes.rewards}/:${RouteParams.rewardId}`,
        loadChildren: () => import("./pages/reward/reward.module").then(m => m.RewardPageModule),
      },
      {
        path: `${AppRoutes.profile}/${AppRoutes.rewards}`,
        redirectTo: `${AppRoutes.loyalty}/${AppRoutes.rewards}`,
        pathMatch: "prefix",
      },
      {
        path: `${AppRoutes.profile}/${AppRoutes.engagementFlows}`,
        redirectTo: `${AppRoutes.loyalty}/${AppRoutes.engagementFlows}`,
        pathMatch: "full",
      },
      {
        path: `${AppRoutes.profile}/${AppRoutes.data}`,
        redirectTo: AppRoutes.profile,
        pathMatch: "full",
      },
      // ----
      {
        path: AppRoutes.profile,
        loadChildren: () => import("./pages/profile/profile.module").then(m => m.ProfilePageModule),
      },
      {
        path: AppRoutes.orders,
        loadChildren: () => import("./pages/orders/orders.module").then(m => m.OrdersPageModule),
      },
      {
        path: AppRoutes.coupons,
        loadChildren: () => import("./pages/coupons/coupons.module").then(m => m.CouponsPageModule),
      },
      {
        path: `${AppRoutes.loyalty}/${AppRoutes.rewards}/:${RouteParams.rewardId}`,
        loadChildren: () => import("./pages/reward/reward.module").then(m => m.RewardPageModule),
      },
      {
        path: `${AppRoutes.loyalty}/${AppRoutes.tiers}`,
        loadChildren: () => import("./pages/tiers/tiers.module").then(m => m.TiersPageModule),
      },
      {
        path: AppRoutes.loyalty,
        loadChildren: () => import("./pages/loyalty/loyalty.module").then(m => m.LoyaltyPageModule),
      },
      {
        path: AppRoutes.info,
        loadChildren: () => import("./pages/info/info.module").then(m => m.InfoPageModule),
      },
      {
        path: AppRoutes.advantages,
        loadChildren: () => import("./pages/advantages/advantages.module").then(m => m.AdvantagesPageModule),
      },
      {
        path: AppRoutes.unauthorized,
        loadChildren: () => import("./pages/unauthorized/unauthorized.module").then(m => m.UnauthorizedPageModule),
      },
      {
        path: AppRoutes.unauthorizedDownload,
        loadChildren: () =>
          import("./pages/unauthorized-download/unauthorized-download.module").then(m => m.UnauthorizedDownloadPageModule),
      },
      {
        path: AppRoutes.giftCard,
        loadChildren: () => import("./pages/gift-card/gift-card.module").then(m => m.GiftCardPageModule),
      },
      {
        path: AppRoutes.referrals,
        loadChildren: () => import("./pages/referral/referral.module").then(m => m.ReferralPageModule),
      },
      {
        path: AppRoutes.completeProfile,
        loadChildren: () => import("./pages/complete-profile/complete-profile.module").then(m => m.CompleteProfilePageModule),
      },
      {
        path: AppRoutes.memberGetMember,
        loadChildren: () => import("./pages/member-get-member/member-get-member.module").then(m => m.MemberGetMemberPageModule),
      },
      {
        path: `:${RouteParams.accessToken}`,
        loadChildren: () => import("./pages/auth/auth.module").then(m => m.AuthPageModule),
      },
      {
        path: "**",
        pathMatch: "full",
        redirectTo: AppRoutes.check,
      },
    ],
  },
  {
    path: "**",
    pathMatch: "full",
    redirectTo: AppRoutes.notFound,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
